export default "__VITE_ASSET__fb68567c__"